<template>
    <div class="table_wrap">
        <div class="table_search row has_bc">
            <el-row>
                <el-col :span="12" >
                </el-col>
                <el-col :span="12" class="text_right">
                </el-col>
            </el-row>
        </div>
        <el-table
                :data="boardData"
                style="width: 100%"
                empty-text="데이터가 없습니다."
                @selection-change="tableSelectChange"

        >
            <el-table-column
                    type="selection"
                    width="55"
                    class-name="text-center"
            >
            </el-table-column>
            <el-table-column
                    class="table_no"
                    type="index"
                    label="No"
                    width="80"
                    class-name="num text-center"
                    :index="tableIdx"
            >
            </el-table-column>
            <el-table-column
                    label="언어" width="150" class-name="text-center">
                <template slot-scope="scope">
                    <span>
                        {{scope.row.Language[0].c_lang_ko}}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="제목" prop="wr_subject" class-name="text-center"></el-table-column>
            <el-table-column
                    label="작성일" width="150" class-name="text-center">
                <template slot-scope="scope">
                    <span>
                        {{returnDate(scope.row.created_at)}}
                    </span>
                </template>
            </el-table-column>
            <el-table-column
                    label="옵션" width="150" class-name="text-center">
                <template slot-scope="scope">
                    <div>
                        <el-button
                                size="mini"
                                type="warning"
                                @click="goDetail(scope.row.wr_id)"
                        >
                            수정
                        </el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>

</template>

<script>
    import {mapState, mapGetters} from "vuex";
    export default {
        name: "BoardListJstNoticeLayout",
        mixins: [],
        components: {
        },
        props: {
            boardData: {
                type: Array,
                default: () => {return []},
            },
            paginationData: {
                type: Object,
                default: {
                    total: 0,
                    page: 0,
                    size: 0,
                }
            },
            categorys: {
                type: Array,
                default: () => {return []},
            },
            setData: {
                type: Function,
                default: () => {}
            }
        },
        data() {
            return {
                selectArr: []
            }
        },
        beforeRouterEnter() {},
        created() {
        },
        mounted() {

        },
        beforeDestroy() {
        },
        destroyed() {},
        computed: {
            ...mapState({
                countries: state => state.country.countries
            })
        },
        methods:{
            goDetail(no) {
                let nowPath = this.$route.path;
                this.$router.push(`${nowPath}/${no}`);
            },
            returnLangName(c_idx) {
                let countryIndex = this.countries.findIndex(country => Number(country.c_idx) === Number(c_idx));
                if(countryIndex < 0) {
                    return '';
                }
                return this.countries[countryIndex].lang_name_kr;
            },
            tableIdx(index) {
                return this.paginationData.total - index - (this.paginationData.page - 1) * this.paginationData.size;
            },
            tableSelectChange(row) {
                this.selectArr = row;
                this.setData('selectArr', this.selectArr)
            },
            returnDate(date=null) {
                if(!date) {
                    return '';
                }
                return this.$moment.unix(date).locale('ko').format('YYYY-MM-DD HH:mm')
            },
        },
        watch: {

        },
    }
</script>

<style scoped>

</style>